import { CardLoader } from 'components/organisms'
import withLoader from 'hocs/with-loader'
import PropTypes from 'prop-types'
import React from 'react'
import { Table } from 'reactstrap'
import { PaymentMethodPagination } from 'domains/payment-method/components'
import BankTransferTableRow from './bank-transfer-table-row'

const propTypes = {
  tableProps            : PropTypes.object,
  bankTransfers         : PropTypes.array,
  pagination            : PropTypes.object,
  onPageChange          : PropTypes.func,
  isLoading             : PropTypes.bool,
  onClickChangeIsActive : PropTypes.func,
  onClickDetail         : PropTypes.func
}

const defaultProps = {
  isLoading: true
}

/**
 * Table to display specific ::BankTransfer columns
 * @param {Array<Object>} data - array of bank_transfers objects
 * @param {Object} pagination - object of pagination data from endpoint
 * @param {Function} onPageChange - function that will handle Page Change
 * @param {Boolean} isLoading - boolean for withLoader animation
 */

const BankTransferTable = ({
  tableProps,
  bankTransfers,
  pagination,
  isLoading,
  onPageChange
}) => {

  const totalColumns         = 9
  const isPaymentMethodEmpty = bankTransfers.length === 0

  const TableContent = () => (
    <Table { ...tableProps }>
      <thead>
        <th colSpan={ 9 } className='text-center'>
          { 'Bank Transfer Payment' }
        </th>
      </thead>
      <thead>
        <tr>
          <th scope="col"><>Transfer<br/>Date</></th>
          <th scope="col">Order No.</th>
          <th scope="col">Name</th>
          <th scope="col">Total</th>
          <th scope="col">Description</th>
          <th scope="col"><>Order<br/>expired<br/>date</></th>
          <th scope="col"><>order<br/>cancelable</></th>
          <th scope="col">status</th>
          <th scope="col">action</th>
        </tr>
      </thead>
      <tbody>
        {
          bankTransfers.map((bankTransfer) => (
            <BankTransferTableRow
              key={ `BankTransferTableRow-${bankTransfer.id}` }
              bankTransfer={ bankTransfer }
            />
          ))
        }
        {
          isPaymentMethodEmpty && (
            <tr>
              <td
                colSpan={ totalColumns }
                className='bg-warning text-white'
              >
                <i className='fas fa-info-circle mr-3' />
                { 'No Bank Transfer Payment found based on your filters.' }
              </td>
            </tr>
          )
        }
      </tbody>
    </Table>
  )

  const TableContentWithLoader = withLoader(TableContent, CardLoader)

  return (
    <>
      <PaymentMethodPagination
        onClickPage={ onPageChange }
        pagination={ pagination }
      />
      <TableContentWithLoader isLoading= { isLoading } />

      <PaymentMethodPagination
        onClickPage={ onPageChange }
        pagination={ pagination }
      />
    </>
  )
}


BankTransferTable.propTypes    = propTypes
BankTransferTable.defaultProps = defaultProps

export default BankTransferTable
